import clsx from 'clsx'
import React from 'react'

const roundedStyles = 'first:rounded-t-lg last:rounded-b-lg'

type SectionCardProps = {
  children?: React.ReactNode
  className?: string
}
export function SectionCard({ children, className }: SectionCardProps) {
  return (
    <section className={clsx('shadow-card rounded-lg ', className)}>
      {children}
    </section>
  )
}

type SectionCardHeaderProps = {
  children?: React.ReactNode
  className?: string
  withPadding?: boolean
  variant?: 'gradient-blue' | 'white' | 'light-blue'
}
const VARIANT_STYLES: Record<SectionCardHeaderProps['variant'], string> = {
  'gradient-blue':
    'bg-gradient-to-r from-cyan-80 from-50% to-cyan-40 to-100% text-white',
  white: 'bg-white text-default',
  'light-blue': 'bg-light-blue text-default',
}
export function SectionCardHeader({
  children,
  className,
  withPadding = true,
  variant = 'white',
}: SectionCardHeaderProps) {
  return (
    <header
      className={clsx(
        'bg-surface-selected-default rounded-t-lg items-center',
        withPadding && 'p-6',
        roundedStyles,
        VARIANT_STYLES[variant],
        className
      )}
    >
      {children}
    </header>
  )
}

type SectionCardBodyProps = {
  children?: React.ReactNode
  className?: string
}
export function SectionCardBody({ children, className }: SectionCardBodyProps) {
  return (
    <div className={clsx('bg-white', roundedStyles, className)}>{children}</div>
  )
}

type SectionCardFooterProps = {
  children?: React.ReactNode
  className?: string
}
export function SectionCardFooter({
  children,
  className,
}: SectionCardFooterProps) {
  return (
    <footer
      className={clsx(
        'bg-white flex p-5 border-t border-subdued',
        roundedStyles,
        className
      )}
    >
      {children}
    </footer>
  )
}
